import React, { useEffect, useState } from "react";
import folderpng from "../../assets/images/folder.png";
import moreimg from "../../assets/images/more.svg";
import editimg from "../../assets/images/edit-edit.svg";
import shareimg from "../../assets/images/share.svg";
import deletrtransh from "../../assets/images/deletrtransh.svg";
import PlusCreate from "../../assets/images/add-square.svg";
import CreateFolder from "../../components/Modals/CreateFolder";
import { folderService } from "services/folder.service";
import EditFolder from "components/Modals/EditFolder";
import DeleteAlert from "components/Modals/Alertpopus/DeleteAlert";
import { toast } from "react-toastify";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ShareFolder from "components/Modals/ShareFolder";
import star from "../../assets/images/star.svg";
import Loader from "components/Loader";
import useFolderList from "hooks/useFolderList";
import { Nav } from "react-bootstrap";
import notify from "../../assets/images/Notification.png";

const ManageFiles = () => {
  const [show, setShow] = useState(false);
  const [editshow, setEditShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false)
  const [shareShow, setShareShow] = useState(false)
  const [data, setData] = useState(false);
  const [folder, setfolder] = useState('')
  const [folderId, setfolderId] = useState('')
  const [loading, setLoading] = useState(false)
  const [selectedFolder, setSelectedFolder] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const [jobId, setJobId] = useState(null);
  const [dataLength, setDataLength] = useState({
    skip: 0,
    limit: 10
  });
  const { foldersData } = useFolderList(dataLength);

  const navigate = useNavigate()

  useEffect(() => {
    const id = searchParams.get('jobId');
    id && setJobId(id)
  }, [])

  useEffect(() => {
    setData(foldersData);
  }, [foldersData]);


  const handleClose = () => {
    setShow(false)
    setEditShow(false)
    setDeleteShow(false)
    setShareShow(false)
  }

  const handleFolderClick = (folder) => {
    jobId && setSelectedFolder(folder);
  };

  const handleAttachFolder = async () => {
    try {
      const payload = {
        jobId: jobId,
        folderId: selectedFolder
      }
      const response = await folderService.attachfolder(payload);
      setData(response?.data?.data);
      toast.success(response?.data?.message)
      navigate('/my-jobs')
    }
    catch (err) {
      console.error(err?.response);
    }
  }

  const handleViewMore = () => {
    const data = dataLength;
    setDataLength({
      ...data,
      limit: data?.limit + 10
    })
  }

  return (
    <div className="container-box">
      <Loader loading={loading} />
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>Manage Files</h2>
        {/* <Nav.Link as={Link} to="/notification" href="/notification">
          <div type="" className=" position-relative">
            <img src={notify} alt="" />
            <span className="position-absolute  badge-custom  rounded-circle">
              <span className="visually-hidden">New alerts</span>
            </span>
          </div>
        </Nav.Link> */}
        <div>
          <div className="d-flex gap-4 cursor-pointer">
            <h5 onClick={() => { setShow(true) }} className="text-white">
              <img src={PlusCreate} className="me-2" style={{ filter: 'invert(1) brightness(100)' }} alt=""></img>Create Folder
            </h5>
            { }
            {selectedFolder && jobId && (
              <h5 onClick={handleAttachFolder}>
                <img src={shareimg} className="me-2" style={{ filter: 'invert(1) brightness(100)' }} alt=""></img>Share Folder
              </h5>
            )}
          </div>

          <CreateFolder show={show} handleClose={handleClose} loading={loading} setLoading={setLoading} data={data} setData={setData} />
        </div>
      </div>
      {data?.totalFolders === 0 ? (<>
        <div className="outer-white mission-div w-100 mx-auto">
          <div className="mt-2 ">
            <div className="disaster-card mx-auto text-center">
              <div className="alert-distaster mx-auto">
                <img src={star} alt="" />
              </div >
              <h2>No Items Available!</h2>
            </div >
          </div >
        </div >
      </>) :
        (<>
          <div className="outer-white job-details-page">
            <div className="d-sm-flex folder-row-cards justify-content-md-start justify-content-center  gap-4 flex-sm-wrap">
              {data?.folders?.map((item, i) => {
                return <>
                  <div className={`folder-outer ${selectedFolder === item?._id ? 'selected' : ''}`} index={item?._id} onClick={() => handleFolderClick(item?._id)}>
                    <div className='file_box mb-2 '
                      style={selectedFolder === item._id ? { backgroundColor: '#5794d7', color: 'white' } : {}}
                    >
                      <img src={folderpng} alt=""></img>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p style={{ width: "80%", wordBreak: 'break-word' }} className="line-clamp">{item?.title}</p>
                      {jobId ? null : (<>

                        <div className="dropdown">
                          <div
                            className="dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img src={moreimg} alt=""></img>
                          </div>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                              <button className="dropdown-item" onClick={() => {
                                setShareShow(true)
                                setfolderId(item?._id)
                              }}>
                                <img src={shareimg} className="me-3" alt=""></img>Share
                              </button>
                            </li>
                            <ShareFolder show={shareShow} handleClose={handleClose} folderId={folderId} />
                            <li>
                              <button className="dropdown-item" onClick={() => {
                                setEditShow(true)
                                setfolder(item)
                              }
                              }>
                                <img src={editimg} className="me-3" alt=""></img>Edit
                              </button>
                            </li>
                            {editshow && <EditFolder show={editshow} handleClose={handleClose} folder={folder} loading={loading} setLoading={setLoading} data={data} setData={setData} />}
                            <li>
                              <button className="dropdown-item" onClick={() => {
                                setDeleteShow(true)
                                setfolder(item)
                                setfolderId(item?._id)
                              }}>
                                <img src={deletrtransh} className="me-3" alt=""></img>Delete
                              </button>
                            </li>
                            {deleteShow && <DeleteAlert show={deleteShow} handleClose={handleClose} folderId={folder?._id} loading={loading} setLoading={setLoading} data={data} setData={setData} />}
                          </ul>
                        </div>

                      </>)}

                    </div>
                  </div>
                </>
              })}

            </div>
          </div>
        </>)}

      {data?.folders?.length < data?.totalFolders && <div className="text-center py-3" style={{ maxWidth: '300px', margin: "auto" }}>
        <button className=" blue-btnnn text-white border-0" onClick={handleViewMore}>
          PMore
        </button>
      </div>}
    </div>

  );
};

export default ManageFiles;
